import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Box, BoxProps } from '../../../../next-components/box';
import { bounce } from '../../keyframes/bounce';
export type FabBouncerProps = BoxProps & {
  children: ReactNode;
};
export const FabBouncer = ({
  children,
  ...rest
}: FabBouncerProps) => <StyledBox bottom="16px" position="fixed" width="300px" zIndex={1000} {...rest} data-sentry-element="StyledBox" data-sentry-component="FabBouncer" data-sentry-source-file="FabBouncer.tsx">
    {children}
  </StyledBox>;
const StyledBox = styled(Box)`
  animation: ${bounce} 4s ease infinite;
`;